'use client';

import clsx from 'clsx';
import { FooterButton } from '@/components/ui/common/buttons';
import CustomLink from '@/components/ui/common/custom-link';
import Image from 'next/image';
import { useLocale } from '@/components/providers/context/locale-context';

function ViewpointItem({
    readMoreButtonText,
    href,
    content,
    topic,
    title,
    imageUrl,
    imageDesc,
    overview,
    reverse,
}: Readonly<{
    readMoreButtonText: string;
    href: string;
    content: { isLink: boolean; text: string; href: string }[];
    topic: string;
    title: string;
    imageUrl: string;
    imageDesc: string;
    overview: string;
    reverse: boolean;
}>) {
    const locale = useLocale();
    const leftQuotation = locale === 'en' ? '"' : '“';
    const rightQuotation = locale === 'en' ? '"' : '”';

    return (
        <div className="flex w-full flex-row">
            <h3 className="hidden">{topic}</h3>
            <div
                className={clsx('j-h3 hidden flex-none text-[#515151] sm:flex')}
            >
                {leftQuotation}
            </div>
            <div className="flex grow flex-col">
                <div
                    className={clsx(
                        'flex w-full flex-row text-[#515151] sm:w-[60%]',
                        'j-h3',
                    )}
                >
                    <div className="block sm:hidden">{leftQuotation}</div>
                    <div>
                        {overview}
                        <span>{rightQuotation}</span>
                    </div>
                </div>
                <div
                    className={clsx(
                        'mt-[40px] flex items-stretch gap-[32px] sm:mt-[120px] sm:gap-[80px]',
                        {
                            'flex-col sm:flex-row-reverse': reverse,
                            'flex-col sm:flex-row': !reverse,
                        },
                    )}
                >
                    <div className="flex h-full w-full flex-row items-center justify-center overflow-hidden sm:basis-1/2">
                        <Image
                            alt={imageDesc}
                            src={imageUrl}
                            width={16}
                            height={9}
                            sizes="100vw"
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                                objectPosition: 'center',
                                transition: 'none', // 添加这一行来取消动画效果
                                userSelect: 'none', // 添加这一行来禁止选中元素的内容
                            }}
                        />
                    </div>
                    <div className="mt-[40px] flex h-full w-full flex-col justify-center sm:mt-0 sm:basis-1/2">
                        <div className={clsx('j-h2')}>{title}</div>
                        <div className="mb-[32px] mt-[16px]">
                            <div className={clsx('j-h5 w-full')}>
                                {content.map((item, index) => {
                                    const key = `${item.text}-${index}`;
                                    return (
                                        <span key={key}>
                                            {item.isLink ? (
                                                <CustomLink href={item.href}>
                                                    {item.text}
                                                </CustomLink>
                                            ) : (
                                                item.text
                                            )}
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                        <FooterButton
                            icon={
                                <svg
                                    className={`inline-block h-[16px] w-[16px] align-middle`}
                                    viewBox="0 0 1024 1024"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M235.093333 215.466667v85.333333h427.946667l-477.866667 477.866667 60.16 60.16 477.866667-477.866667v427.946667h85.333333V215.466667z"></path>
                                </svg>
                            }
                            textColor="#000000"
                            textHoverColor="#FFFFFF"
                            borderColor="#000000"
                            boderHoverColor="#000000"
                            bgHoverColor="#000000"
                            iconColor="#000000"
                            iconHoverColor="#FFFFFF"
                            iconSize={[16, 16]}
                            iconSize4Mobile={[16, 16]}
                            className={clsx(
                                'j-t2 h-[36px] w-[135px] sm:h-[40px]',
                                {
                                    'sm:w-[147px]': locale === 'en',
                                    'sm:w-[128px]': locale === 'zh',
                                },
                            )}
                            text={readMoreButtonText}
                            onClick={() => {
                                // 新开tab页，跳转到href
                                window.open(href, '_blank');
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewpointItem;
